import Main from "../Pages/Documentation/Scope1/StationaryCombustion/Main";
import Scope2DocumentationElectricity from "../Pages/Documentation/Scope2/Electricity/Main";
import Scope2DocumentationHeat from "../Pages/Documentation/Scope2/Heat/Main";
import Scope2DocumentationSteam from "../Pages/Documentation/Scope2/Steam/Main";
import GoodsService from "../Pages/Documentation/Scope3/GoodsService/GoodsService";
import BusinessTravelDocuments from "../Pages/Documentation/Scope3/BusinessTravel/BusinessTravel";
import EmployeeCommuteDocuments from "../Pages/Documentation/Scope3/EmployeeCommute/EmployeeCommute";
import TransportationDocuments from "../Pages/Documentation/Scope3/Transportation/Transportation";
import WasteGeneratedDocuments from "../Pages/Documentation/Scope3/WasteGenerated/WasteGenerated";
import CapitalGoodsDocuments from "../Pages/Documentation/Scope3/CapitalGoods/CapitalGoods";
import UpstreamLeasedAssetsDocuments from "../Pages/Documentation/Scope3/UpstreamLeasedAssets/UpstreamLeasedAssets";
import DownstreamLeasedAssetsDocuments from "../Pages/Documentation/Scope3/DownstreamLeasedAssets/DownstreamLeasedAssets";
import ProcessingOfSoldProductsDocuments from "../Pages/Documentation/Scope3/ProcessingOfSoldProducts/ProcessingOfSoldProducts";
import UseOfSoldProductsDocuments from "../Pages/Documentation/Scope3/UseOfSoldProducts/UseOfSoldProducts";
import EOLTreatmentOfSoldProductsDocuments from "../Pages/Documentation/Scope3/EOLTreatmentOfSoldProducts/EOLTreatmentOfSoldProducts";
import FranchisesDocuments from "../Pages/Documentation/Scope3/Franchises/Franchises";
import InvestmentsDocuments from "../Pages/Documentation/Scope3/Investments/Investments";
import FuelEnergyActivitiesDocuments from "../Pages/Documentation/Scope3/FuelEnergyActivities/FuelEnergyActivities";
import MobileCombustionDocuments from "../Pages/Documentation/Scope1/MobileCombustion/MobileCombustionDocuments";
import FugitiveEmissionDocuments from "../Pages/Documentation/Scope1/FugitiveEmission/FugitiveEmissionDocuments";
import Social from "../Pages/Documentation/Social";
import GovernanceDocuments from "../Pages/Documentation/Governance/Governance";
import CarbonAvoidanceMain from "../Pages/Documentation/Scope4/CarbonAvoidance/RenewableEnergyExports/Main";
import CarbonOffsetMain from "../Pages/Documentation/Scope4/CarbonOffset/InHouseOffset/Main";

export const DocumentationRoutes = [
  {
    path: "/documentation/scope1/stationary-combustion",
    element: <Main />,
  },

  {
    path: "/documentation/scope1/mobile-combustion",
    element: <MobileCombustionDocuments />,
  },
  {
    path: "/documentation/scope1/fugitive-combustion",
    element: <FugitiveEmissionDocuments />,
  },
  {
    path: "/documentation/scope2/Electricity",
    element: <Scope2DocumentationElectricity />,
  },

  {
    path: "/documentation/scope2/Heat",
    element: <Scope2DocumentationHeat />,
  },

  {
    path: "/documentation/scope2/Steam",
    element: <Scope2DocumentationSteam />,
  },
  {
    path: "/documentation/scope3/goods-services",
    element: <GoodsService />,
  },
  {
    path: "/documentation/scope3/transportation",
    element: <TransportationDocuments />,
  },
  {
    path: "/documentation/scope3/employee-commute",
    element: <EmployeeCommuteDocuments />,
  },
  {
    path: "/documentation/scope3/business-travel",
    element: <BusinessTravelDocuments />,
  },
  {
    path: "/documentation/scope3/waste-generated",
    element: <WasteGeneratedDocuments />,
  },
  {
    path: "/documentation/scope3/capital-goods",
    element: <CapitalGoodsDocuments />,
  },
  {
    path: "/documentation/scope3/upstream-leased-assets",
    element: <UpstreamLeasedAssetsDocuments />,
  },
  {
    path: "/documentation/scope3/downstream-leased-assets",
    element: <DownstreamLeasedAssetsDocuments />,
  },
  {
    path: "/documentation/scope3/processing-of-sold-products",
    element: <ProcessingOfSoldProductsDocuments />,
  },
  {
    path: "/documentation/scope3/use-of-sold-products",
    element: <UseOfSoldProductsDocuments />,
  },
  {
    path: "/documentation/scope3/eol-treatment-of-sold-products",
    element: <EOLTreatmentOfSoldProductsDocuments />,
  },
  {
    path: "/documentation/scope3/franchises",
    element: <FranchisesDocuments />,
  },
  {
    path: "/documentation/scope3/investments",
    element: <InvestmentsDocuments />,
  },
  {
    path: "/documentation/scope3/fuel-energy-activities",
    element: <FuelEnergyActivitiesDocuments />,
  },
  {
    path: "/documentation/scope4/carbon-avoidance",
    element: <CarbonAvoidanceMain />,
  },
  {
    path: "/documentation/scope4/carbon-offset",
    element: <CarbonOffsetMain />,
  },

  {
    path: "/documentation/social",
    element: <Social />,
  },

  {
    path: "/documentation/governance/governance",
    element: <GovernanceDocuments />,
  },
];
